/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { css } from 'emotion';
import ReactTooltip from 'react-tooltip';
import i18next from 'i18next';

import { Row } from '~/modules/coreUI/components/legacies/Rows';
import { LargeSpacer } from '~/modules/coreUI/components/legacies/Spacers';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import Tooltip from '~/modules/ecommerceCoreUI/components/basic/tooltip';

const CategoryButton = styled.i`
  display: flex;
  padding: ${props => props.theme.paddings.medium}px;
  ${props => cssMediaMax.xsmall`
    padding: ${props.theme.paddings.normal}px;
  `};
  justify-content: center;
  align-items: center;
  background-color: #ededed;
  color: #87898c;
  ${props => props.active
    && css`
      color: ${props.theme.colors.named.white};
      background-color: ${props.theme.colors.primary};
    `};
  font-size: 19px;
  ${cssMediaMax.xsmall`
    font-size: 17px;
  `};
  font-family: fontello, sans-serif;
  border-radius: ${props => props.theme.borders.radius.small}px;
  cursor: pointer;
`;

const ChangeCardsView = ({ isVertical, changeView }) => {
  const handleChangeView = (value) => {
    ReactTooltip.rebuild();
    if (value === 'list') {
      changeView(false);
    } else {
      changeView(true);
    }
  };
  return (
    <Row justifyCenter>
      <Tooltip title={i18next.t('ecommerceCoreUI:ToolTipTrans.list')}>
        <CategoryButton
          size={19}
          active={isVertical === false}
          onClick={() => {
            handleChangeView('list');
          }}
          onKeyDown={() => handleChangeView('list')}
          className="icon-list-1"
        />
      </Tooltip>
      <LargeSpacer />
      <Tooltip title={i18next.t('ecommerceCoreUI:ToolTipTrans.grid')}>
        <CategoryButton
          size={19}
          active={isVertical === true}
          onClick={() => {
            handleChangeView('grid');
          }}
          onKeyDown={() => handleChangeView('grid')}
          className="icon-grid"
        />
      </Tooltip>
    </Row>
  );
};

ChangeCardsView.propTypes = {
  changeView: PropTypes.func.isRequired,
  isVertical: PropTypes.bool.isRequired,
};

export default ChangeCardsView;
